import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { getDetailPost, editPost, deletePost } from 'api/blog';
//components
import Title from 'components/backoffice/texts/title';
import PostsForm from 'components/backoffice/forms/postsForm';

const EditPost = () => {
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [post, setPost] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setTitle} = useOutletContext()

  const detailPost = async () => {
    try {
      const { data, status } = await getDetailPost(id);
      if (status === 200) {
        setPost(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    detailPost();
  }, []);

  useEffect(() => {
    if(post){
      setTitle(t('edit', {title:post?.title}))
    }
    return () => {
      setTitle('');
    };
  },[post, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const data = {
      title: values?.title,
      body: values?.body,
      featured_paragraph: values?.featured_paragraph,
      ...(values?.featured_image instanceof File ? { featured_image: values?.featured_image } : {}),
      status: values?.status,
      category: parseInt(values?.category, 10),
    };
    try {
      const { status } = await editPost(id, data);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/posts', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);

  const handleDelete = useCallback(
    async () => {
      try {
        const { status } = await deletePost(id);
        if (status === 204) {
          toast.success(t('eliminadocorrectamente'));
          navigate('/intranet/posts', { replace: true });
        } else {
          toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
        }
      } catch (error) {
        console.log(error);
      }
    },
    [openModalDelete],
  );

  return (
    <div className="post-edit mt-5">
      <Title text={t('editpost')} />
      <PostsForm 
        loading={loading} 
        isEditing={true} 
        onSubmitForm={onSubmit} 
        openModalDelete={openModalDelete} 
        setOpenModalDelete={setOpenModalDelete} 
        defaultValues={post} 
        onDelete={handleDelete} 
        id={id} 
        fileInputRef={fileInputRef}
      />
    </div>
  );
};

export default EditPost;
